import React, { useState } from "react";
import "./styles.css";
import ExitIcon from "../ExitIcon";
import CloseIcon from "../CloseIcon";
import VrIcon from "../VrIcon";
import ArIcon from "../ArIcon";
import MuteIcon from "../MuteIcon";
import OrbitIcon from "../OrbitIcon";

const BottomMenu = ({
  onEnterVR,
  onEnterAR,
  onCloseSession,
  onLeaveSession,
  onToggleMuteMyself,
  onCloseTrial,
  isVrUser,
  isArUser,
  isAdmin,
  isAudioEnabled,
  amIMuted,
  isAttendee,
  isTryingRoom,
  isConnectedToASession,
  onShowHelpOverlay,
  onChangeControls,
  isOrbitControls,
}) => {
  return (
    <div className="bottom-menu-container">
      {isVrUser && (!isAttendee || isTryingRoom) && <VrIcon handleClick={onEnterVR} />}

      {isArUser && (!isAttendee || isTryingRoom) && <ArIcon handleClick={onEnterAR} />}

      {isAdmin && isConnectedToASession && <CloseIcon handleClick={onCloseSession} />}

      {isTryingRoom && <ExitIcon handleClick={onCloseTrial} />}

      {!isAdmin && !isTryingRoom && <ExitIcon handleClick={onLeaveSession} />}

      {isAudioEnabled && !isAttendee && (
        <MuteIcon handleClick={() => onToggleMuteMyself({ amIMuted: !amIMuted })} isActive={amIMuted} />
      )}

      <OrbitIcon isActive={isOrbitControls} handleClick={() => onChangeControls(!isOrbitControls)} />
    </div>
  );
};
export default BottomMenu;
